import { DressingWeight, type MixedDressingDetails } from '@sg/graphql-schema';

import { type Modification } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export function generateMixedDressingDetailsFactory(
  hasMultipleMixableDressings: boolean,
  currentMixedDressingDetails: MixedDressingDetails[],
) {
  const defaultWeight = hasMultipleMixableDressings
    ? DressingWeight.Light
    : DressingWeight.Medium;

  return (modification: Modification) => {
    const maybeDressingDetail = currentMixedDressingDetails.find(
      ({ ingredientId }) => ingredientId === modification.ingredient?.id,
    );

    if (maybeDressingDetail) {
      return maybeDressingDetail;
    }

    return generateMixedDressingDetails(modification, defaultWeight);
  };
}

// ─────────────────────────────────────────────────────────────────────────────

function generateMixedDressingDetails(
  modification: Modification,
  defaultWeight: DressingWeight,
): MixedDressingDetails | null {
  const { ingredient } = modification;

  if (!ingredient) {
    return null;
  }

  return { ingredientId: ingredient.id, weight: defaultWeight };
}
